import { useSelector } from "react-redux";
import { getRoles } from "./selectors";

export default function useRoles() {
	const roles = useSelector(getRoles);

	return { roles };
}
